import { validateTrigger, ValidationRules } from "aurelia-validation";
import { NotificationType } from "../../../services/basics/notification-client.service";
var BaseClientDetailsDialog = /** @class */ (function () {
    function BaseClientDetailsDialog(tokenClient, validationControllerFactory, notificationService, dialogClient) {
        this.tokenClient = tokenClient;
        this.notificationService = notificationService;
        this.dialogClient = dialogClient;
        this.controller = null;
        this.controller = validationControllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.changeOrBlur;
    }
    BaseClientDetailsDialog.prototype.initValidations = function () {
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Name is required")
            .ensure(function (x) { return x.surname; }).required().withMessage("Surname is required")
            .ensure(function (x) { return x.email; }).email().withMessage("Email must be in the form of someone@something.com")
            .ensure(function (x) { return x.mobile; }).required().withMessage("Mobile is required")
            .ensure(function (x) { return x.prefix; }).required().withMessage("Mobile Prefix is required")
            .on(this)
            .rules;
    };
    BaseClientDetailsDialog.prototype.activate = function (vm) {
        this.vm = vm;
    };
    BaseClientDetailsDialog.prototype.attached = function () {
        this.initValidations();
    };
    BaseClientDetailsDialog.prototype.buyTickets = function () {
        var _this = this;
        this.controller.validate({ object: this, rules: this.rules }).then(function (x) {
            if (x.valid) {
                _this.vm.buyTickets({
                    email: _this.email,
                    mobile: "".concat(_this.prefix.name).concat(_this.mobile),
                    name: _this.name,
                    surname: _this.surname
                }).then(function (x) {
                    _this.dialogClient.hide();
                    _this.showTicketDialog(x);
                }, function (e) { });
            }
            else {
                var errors = _this.controller.errors.map(function (x) { return x.message; }).join("\n");
                _this.notificationService.show("Validation Error!", errors, NotificationType.Error);
            }
        });
    };
    BaseClientDetailsDialog.prototype.showTicketDialog = function (item) {
        var templateName = this.tokenClient.user.templateName.toLowerCase();
        try {
            require("./" + templateName + "/dialogs/ticket-dialog");
        }
        catch (_a) {
            console.log("Cannot load ticket dialog for template " + templateName);
        }
        this.dialogClient.show("app/styles/client/templates/" + templateName + "/dialogs/ticket-dialog", item, true, true);
    };
    return BaseClientDetailsDialog;
}());
export { BaseClientDetailsDialog };
